// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"FacetInput_Inputs__3OTZ2","Separator":"FacetInput_Separator__ICCQY","Title":"FacetInput_Title__1pXe9"};